// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vmTY","buttons":"styles_buttons__3onei"};